import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";

/**
 * MandateReturnScreen - Handles redirect from Bank / NPCI after e-NACH authorization
 * Shows "Mandate submitted for approval" and allows navigation to Mandate Status
 */
export default function MandateReturnScreen() {
  const [searchParams] = useSearchParams();
  const [clientCode, setClientCode] = useState("");
  const [mandateId, setMandateId] = useState("");

  useEffect(() => {
    const cc = searchParams.get("ClientCode") || searchParams.get("clientCode");
    const mid = searchParams.get("MandateID") || searchParams.get("mandateId");
    if (cc) {
      setClientCode(cc);
      sessionStorage.setItem("mandateReturnClientCode", cc);
    }
    if (mid) {
      setMandateId(mid);
      sessionStorage.setItem("mandateReturnMandateId", mid);
    }
  }, [searchParams]);




  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content p-4">
          <div
            className="card shadow-sm mx-auto"
            style={{ maxWidth: "500px", marginTop: "2rem" }}
          >
            <div className="card-body text-center p-4">
              <i className="fas fa-check-circle text-success fa-3x mb-3" />
              <h5 className="text-success">Mandate Submitted for Approval</h5>
              <p className="text-muted mb-4">
                Your mandate has been submitted for authorization. You can check the mandate status from the Mandate Status screen.
              </p>
              <div className="d-flex gap-2 justify-content-center flex-wrap">
                <Link to="/user/mandate-status" state={{ clientCode, mandateId }} className="btn btn-primary">
                  Check Mandate Status
                </Link>
                <Link to="/user" className="btn btn-outline-secondary">
                  Back to Users
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
